import { Box, Button, Grid, Typography } from '@mui/material';
import AsyncAutoComplete from '../../components/common/AsyncAutoSuggest';
import FormsPopup from '../../components/common/FormsPopup/FormsPopup';
import { useToast } from '../../components/common/ToasterContext';
import getAPIUrl from '../../config';
import { putApiWithAuth } from '../../utils/apiCalls';
import { getPartners } from '../PartnerAndMembers/api';
import styles from './styles';
import { VerifyMemberRequestProps } from './types';

const VeriyfMemberRequest = ({
    openVerifyMemberRequest,
    setOpenVerifyMemberRequest,
    verifyMemberRequestData,
    setEmployerId,
    employerId,
    reload,
    setReload,
}: VerifyMemberRequestProps) => {
    const toast = useToast();
    return (
        <FormsPopup
            id="pending_request"
            open={openVerifyMemberRequest}
            title="Pending Request"
            textAlign="left"
            handleClose={() => {
                setReload(!reload);
                setEmployerId('');
                setOpenVerifyMemberRequest(false);
            }}
            width={400}
        >
            <Box component="form" noValidate>
                <Typography data-testid="pending_request_firstname" sx={styles.profileLable}>
                    First Name
                </Typography>
                <Typography sx={[styles.profileValue, styles.cap]}>{verifyMemberRequestData?.firstname}</Typography>

                <Typography data-testid="pending_request_lastname" sx={styles.profileLable}>
                    Last Name
                </Typography>
                <Typography sx={[styles.profileValue, styles.cap]}>{verifyMemberRequestData?.lastname}</Typography>

                <Typography data-testid="pending_request_email" sx={styles.profileLable}>
                    Email
                </Typography>
                <Typography sx={styles.profileValue}>{verifyMemberRequestData?.email}</Typography>

                <Typography data-testid="pending_request_partner" sx={styles.profileLable}>
                    Partner
                </Typography>
                <Typography sx={[styles.profileValue, styles.cap]}>{verifyMemberRequestData?.employerName}</Typography>

                <Typography
                    component="div"
                    sx={{
                        mt: '24px',
                    }}
                >
                    <AsyncAutoComplete
                        id="employerId"
                        async={async (value) => {
                            const res = await getPartners({
                                currentPage: 1,
                                partnerSearchText: value,
                                partnerSize: 10000,
                                selectedPartnerPeriod: '',
                                selectedPartnerStatus: 'active',
                                sort: 'name',
                                order: 'asc',
                            });
                            return res.data.data.rows;
                        }}
                        label="Select Partner To Send Unique ID"
                        optionLabel="name"
                        defaultValue={{
                            name: verifyMemberRequestData?.employerName || '',
                            id: verifyMemberRequestData?.employerId || '',
                        }}
                        handleSelectedoption={(selectedOption) => {
                            setEmployerId(selectedOption?.id || '');
                        }}
                    />
                </Typography>

                <Grid container spacing={2} sx={styles.container}>
                    <Grid item xs={5}>
                        <Button
                            id="denyAccess"
                            variant="text"
                            sx={styles.denyAccess}
                            onClick={async () => {
                                try {
                                    await putApiWithAuth(`${getAPIUrl()}/admins/member-requests/deny-request`, {
                                        id: Number(verifyMemberRequestData?.id),
                                    });
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onSuccess();
                                        toast.onMessage('Request Processeed');
                                    }
                                    setReload(!reload);
                                    setEmployerId('');
                                    setOpenVerifyMemberRequest(false);
                                } catch (error: any) {
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onError();
                                        toast.onMessage(error.response.data.errors);
                                    }
                                }
                            }}
                        >
                            Deny Access
                        </Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Button
                            variant="contained"
                            color="success"
                            sx={styles.profileButton}
                            disabled={employerId === ''}
                            onClick={async () => {
                                try {
                                    await putApiWithAuth(`${getAPIUrl()}/admins/member-requests/approve-request`, {
                                        id: Number(verifyMemberRequestData?.id),
                                        employerId: Number(employerId),
                                    });
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onSuccess();
                                        toast.onMessage('Request Processeed');
                                    }
                                    setReload(!reload);
                                    setEmployerId('');
                                    setOpenVerifyMemberRequest(false);
                                } catch (error: any) {
                                    if (toast) {
                                        toast.onToggleSnackbar();
                                        toast.onError();
                                        toast.onMessage(error.response.data.errors);
                                    }
                                }
                            }}
                            id="approveAccess"
                        >
                            Approve Access
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </FormsPopup>
    );
};
export default VeriyfMemberRequest;
